
import React from 'react';
import { Container, Card, ListGroup, Table, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../App.css';

const ScoringPage: React.FC = () => {
  return (
    <Container className="mt-5 mb-5">
      <Card className="shadow-sm home-card">
        <Card.Header as="h4" className="card-title-custom text-center">Fantasy Scoring Rubric</Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <Card className="mb-4">
                <Card.Header as="h5">Challenge Wins</Card.Header>
                <ListGroup variant="flush">
                  <ListGroup.Item>Tribe Immunity Win: <strong>1 pt</strong></ListGroup.Item>
                  <ListGroup.Item>Tribe Reward Win: <strong>1 pt</strong></ListGroup.Item>
                  <ListGroup.Item>Individual Reward Win: <strong>2 pts</strong></ListGroup.Item>
                  <ListGroup.Item>Shot in the Dark Win: <strong>4 pts</strong></ListGroup.Item>
                </ListGroup>
              </Card>

              <Card className="mb-4">
                <Card.Header as="h5">Strategic Moves</Card.Header>
                <ListGroup variant="flush">
                  <ListGroup.Item>On the Right Side of the Vote: <strong>1 pt</strong></ListGroup.Item>
                  <ListGroup.Item>Immunity Idol Obtained: <strong>4 pts</strong></ListGroup.Item>
                  <ListGroup.Item>Advantage Obtained: <strong>2 pts</strong></ListGroup.Item>
                  <ListGroup.Item>Played Idol or Advantage: <strong>2 pts</strong></ListGroup.Item>
                  <ListGroup.Item>Advantage Abandoned: <strong>-2 pts</strong></ListGroup.Item>
                  <ListGroup.Item>Idol Abandoned: <strong>-3 pts</strong></ListGroup.Item>
                  <ListGroup.Item>Coin Flip Win (Twist): <strong>4 pts</strong> <em>(+4 pts for Idol Obtained, +8 pts total)</em></ListGroup.Item>
                  <ListGroup.Item>Coin Flip Loss: <strong>Immediate Elimination</strong> <em>(voted out)</em></ListGroup.Item>
                  <ListGroup.Item>Correctly Picks person Voted Out (Elimination Pick): <strong>3 pts</strong></ListGroup.Item>
                </ListGroup>
              </Card>

              <Card className="mb-4">
                <Card.Header as="h5">Final Placement</Card.Header>
                <ListGroup variant="flush">
                  <ListGroup.Item>Sole Survivor (1st Place): <strong>25 pts</strong></ListGroup.Item>
                  <ListGroup.Item>Second Place: <strong>10 pts</strong></ListGroup.Item>
                  <ListGroup.Item>Third Place: <strong>5 pts</strong></ListGroup.Item>
                </ListGroup>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="mb-4">
                <Card.Header as="h5">Individual Immunity Wins</Card.Header>
                <Table striped bordered size="sm">
                  <thead>
                    <tr>
                      <th>Players Remaining</th>
                      <th>Points Awarded</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td>13 Players</td><td>3 pts</td></tr>
                    <tr><td>12 Players</td><td>3.5 pts</td></tr>
                    <tr><td>11 Players</td><td>4 pts</td></tr>
                    <tr><td>10 Players</td><td>4.5 pts</td></tr>
                    <tr><td>9 Players</td><td>5 pts</td></tr>
                    <tr><td>8 Players</td><td>5.5 pts</td></tr>
                    <tr><td>7 Players</td><td>6 pts</td></tr>
                    <tr><td>6 Players</td><td>6 pts</td></tr>
                    <tr><td>5 Players</td><td>7 pts</td></tr>
                    <tr><td>4 Players</td><td>7.5 pts</td></tr>
                  </tbody>
                </Table>
              </Card>

              <Card className="mb-4">
                <Card.Header as="h5">Votes Against Penalties</Card.Header>
                <Table striped bordered size="sm">
                  <thead>
                    <tr>
                      <th>Votes Against</th>
                      <th>Points Deducted</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td>1 Vote</td><td>-0.5 pts</td></tr>
                    <tr><td>2 Votes</td><td>-1 pt</td></tr>
                    <tr><td>3 Votes</td><td>-1.5 pts</td></tr>
                    <tr><td>4 Votes</td><td>-2 pts</td></tr>
                    <tr><td>5 Votes</td><td>-2.5 pts</td></tr>
                    <tr><td>6 Votes</td><td>-3 pts</td></tr>
                    <tr><td>7 Votes</td><td>-3.5 pts</td></tr>
                    <tr><td>8 Votes</td><td>-4 pts</td></tr>
                    <tr><td>9 Votes</td><td>-4.5 pts</td></tr>
                    <tr><td>10 Votes</td><td>-5 pts</td></tr>
                    <tr><td>11 Votes</td><td>-5.5 pts</td></tr>
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>

          <div className="text-center mt-4">
            <Link to="/rules" className="btn btn-secondary me-2">Back to Rules</Link>
            <Link to="/" className="btn btn-primary">Back to Home</Link>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ScoringPage;
